import { Button, FormControl, InputLabel, makeStyles } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import { icon_backButton, icon_hamburger } from '../../assets/images/images';
import { HamburgerMenu } from '../../components/ui/HamburgerMenu';
import { InputField } from '../../components/ui/InputField';
import { Logo } from '../../components/ui/Logo';
import { ApplicationUserContext, EaterGroupContext, PlanEatUserContext } from '../../config/Context';
import { data_grid_eater_bookings_columns } from '../../constants/dataGridHeaders';
import { IServiceUserContent } from '../../datasolvr/ServicesFacade';
import { IEaterBookings, IResetPasswordUser } from '../../interface/interface';
import { FrontendApi } from '../../planEatApi/FrontendApi';
import { planEatApi } from '../../planEatApi/PlanEatApi';
import { IOfficeContent, IUserContent } from '../../planEatApi/PlanEatFacade';
import { clone } from '../../utils/clone';
import { extractErrorMessage } from '../../components/utils/ErrorHandler';

const useStyles = makeStyles((theme: any) => ({
    content: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%", 

        "& > *": {
            width: "75%",
        }
    },
    topbarContainer: {
        padding: 10,
        top: 0,
        left: 0,
        right: 0,
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    title: {
        fontSize: '28px',
        fontWeight: 400,
        color: 'black',
        marginBottom: 30,
    },
    highLightedContainer: {
        background: '#FFFFFF',
        boxShadow: '0px 4px 4px rgba(11, 37, 89, 0.1)',
        borderRadius: 8,
        padding: 15,
        marginBottom: 20
    },
    buttonContainer:{
        display: 'grid',
        justifyContent: 'flex-end',
        gridTemplateColumns: '20% 20%',
        width: '100%',
        columnGap: 20,
        marginTop: 15
    },
}));

interface Props {
    
}

export const Profile: React.FC<Props> = ({}) => {
    // Styling 
    const classes = useStyles();

    // State
    const [open, setOpen] = useState(false);
    const [myBookingList, setMyBookingList] = useState<IEaterBookings[]>([]);
    const [serviceUser, setServiceUser] = useState<IServiceUserContent>();
    const [office,setOffice] = useState<IOfficeContent>();
    // State
    const [newCredentials, setCredentials] = useState<IResetPasswordUser>({
        newPassword: '',
        confirmNewPassword: '',
        showPassword: false
        });

    // Context
    const applicationUserContext = useContext(ApplicationUserContext);
    const planEatUserContext = useContext(PlanEatUserContext);
    const eaterGroupContext = useContext(EaterGroupContext)

    // Routing
    const history = useHistory();

    useEffect(() => {
        getMyBookingList()
        getServiceUser()
        getOffice()
    }, [applicationUserContext,eaterGroupContext])

    function getMyBookingList() {
        if(applicationUserContext?.applicationServiceUser && planEatUserContext?.planEatServiceUser){
            FrontendApi.getEatersOwnBookings(applicationUserContext?.applicationServiceUser, planEatUserContext?.planEatServiceUser)
            .then((response) => {
                setMyBookingList(response);
            }).catch((e) => {
                console.log(e)
            })
        }
    }

    function getServiceUser(){
        if(applicationUserContext?.applicationServiceUser){
            planEatApi.getServiceUser(applicationUserContext.applicationServiceUser.content.id)
            .then(response => {
                setServiceUser(response.data.content)
            })
            .catch(e => {
                console.log(e)
            })
        }
    }

    function getOffice(){
        if(eaterGroupContext?.eaterGroup){
            planEatApi.getOffice(eaterGroupContext?.eaterGroup.content.officeId)
            .then((response) => {
                localStorage.setItem("officeId",response.data.content.id)
                setOffice(response.data.content)
            })
            .catch((e) => {
                console.log(e)
            })
        }
    }

    function updateUser(){
        if(serviceUser){
            planEatApi.postServiceUser(serviceUser)
            .then(() => {
                toast.success("User information was updated")
                getServiceUser()
            })
            .catch((e) => {
                extractErrorMessage(e, "Failed updating information")
            })
        } else {
            toast.error("Failed updating user")
        }
    }


    function updatePassword(){
        if(newCredentials.newPassword === newCredentials.confirmNewPassword){
            if(serviceUser && serviceUser.data_raw && serviceUser.data_raw.hash){
                if(newCredentials.newPassword.length <= 0){
                    toast.error("You cannot have empty password")
                } else {
                    serviceUser.data_raw.hash = newCredentials.newPassword
                    planEatApi.postServiceUser(serviceUser)
                    .then(() => {
                        toast.success("Password was updated")
                        localStorage.clear()
                        history.push("")
                    })
                    .catch((e) => {
                        if(e.response.data.content.length > 0){
                            toast.error(e.response.data.content[e.response.data.content.length-1].message)
                        } else {
                            toast.error("Failed updating information")
                        }
                    })
                }
                
            } else {
                toast.error("Failed updating user")
            }
        } else {
            toast.error("Passwords don't match")
        }
    }

    function cancelUpdate(){
        getServiceUser()
        getOffice()
    }

    


    const handleServiceUserChange = (prop: keyof IServiceUserContent) => (event: React.ChangeEvent<HTMLInputElement>) => {
        serviceUser && setServiceUser({ ...serviceUser, [prop]: event.target.value });
    };
    
    const handlePasswordChange = (prop: keyof IResetPasswordUser) => (event: React.ChangeEvent<HTMLInputElement>) => {
        newCredentials && setCredentials({ ...newCredentials, [prop]: event.target.value });
    };


    return (
        <div>
            <div className={classes.topbarContainer}>
                <img src={icon_backButton} onClick={() => { history.push("booking") }} />
                <Logo variant="small" />
                <img onClick={() => { setOpen(true) }} src={icon_hamburger} alt="hamburgerMenu" style={{ cursor: 'pointer' }} />
                <HamburgerMenu open={open} setOpen={setOpen} />
            </div>
            <div className={classes.content}>
                <div className={classes.highLightedContainer}>
                    <div className={classes.title}>Information</div>
                    {
                        serviceUser && eaterGroupContext?.eaterGroup && office &&
                        <div>
                            <InputField
                                fullWidth
                                variant='outlined'
                                id="eaterName"
                                label="Name"
                                name="eaterName"
                                value={serviceUser.name}
                                onChange={handleServiceUserChange('name')}
                                style={{marginBottom: 15}}
                                InputLabelProps={{
                                    shrink: true,
                                }}/>
                            <InputField
                                fullWidth
                                variant='outlined'
                                label="Part of"
                                value={eaterGroupContext?.eaterGroup?.content.eaterGroupName}
                                style={{marginBottom: 15}}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                disabled/>
                            <InputField
                                fullWidth
                                variant='outlined'
                                label="Located at office"
                                value={office.officeName}
                                style={{marginBottom: 15}}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                disabled/>
                            <div className={classes.buttonContainer}>
                                <Button variant="contained" onClick={() => {cancelUpdate()}}>
                                    Cancel
                                </Button>
                                <Button variant="contained" onClick={() => {updateUser()}}>
                                    Update information
                                </Button>
                            </div>
                        </div>
                    }               
                </div>
                <div className={classes.highLightedContainer}>
                    <div className={classes.title}>Update password</div>
                    {
                        serviceUser &&
                        <div>
                            <InputField
                                fullWidth
                                variant='outlined'
                                label="New password"
                                value={newCredentials.newPassword}
                                style={{marginBottom: 15}}
                                type="password"
                                onChange={handlePasswordChange('newPassword')}
                                InputLabelProps={{
                                    shrink: true,
                                }}/>
                            <InputField
                                fullWidth
                                variant='outlined'
                                label="Confirm new password"
                                value={newCredentials.confirmNewPassword}
                                style={{marginBottom: 15}}
                                type="password"
                                onChange={handlePasswordChange('confirmNewPassword')}
                                InputLabelProps={{
                                    shrink: true,
                                }}/>
                            <div className={classes.buttonContainer}>
                                <Button variant="contained" onClick={() => {setCredentials({newPassword:"",confirmNewPassword:"",showPassword:false})}}>
                                    Cancel
                                </Button>
                                <Button variant="contained" onClick={() => {updatePassword()}}>
                                    Update password
                                </Button>
                            </div>
                        </div>
                    }
                </div>
                <div className={classes.highLightedContainer}>
                    <div className={classes.title}>Your bookings</div>
                    <div style={{ display: 'flex', height: '400px' }}>
                        <div style={{ flexGrow: 1 }}>
                            <DataGrid
                                rows={myBookingList}
                                getRowId={(booking) => booking.bookingId}
                                columns={data_grid_eater_bookings_columns}
                                pageSize={10}
                                rowsPerPageOptions={[10]}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}